export const data4_3_2 = [{
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: '',
    name_code: "",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}, {
    name: 'Sub-Total 小计',
    name_code: "Sub_Total",
    m_this_RN: "0",
    m_this_ADR: "0",
    m_this_REV: "0",
    m_last_RN: "0",
    m_last_ADR: "0",
    m_last_REV: "0",
    m_ratio_RN: "0",
    m_RN_percent: "0",
    m_ratio_ADR: "0",
    m_ADR_percent: "0",
    m_ratio_REV: "0",
    m_REV_percent: "0",
    y_this_RN: "0",
    y_this_ADR: "0",
    y_this_REV: "0",
    y_last_RN: "0",
    y_last_ADR: "0",
    y_last_REV: "0",
    y_ratio_RN: "0",
    y_RN_percent: "0",
    y_ratio_ADR: "0",
    y_ADR_percent: "0",
    y_ratio_REV: "0",
}];


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-3/data4.js